/**
 * Code executed for components implemented in Cod app.
 */
import type { Store } from "redux";
import { getCodBuildURLs } from "./codUtils";
import { startConfigSave } from "../redux/actions/SaveActions";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";
import { isCodCustomer, isCodDealer } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

export default (settings: CommonSettingsType, store: Store): void => {
    if (isCodDealer(settings) || isCodCustomer(settings)) {
        const sendDataToCod = (topic: string, data: unknown): void =>
            window.postMessage(JSON.stringify({ topic, data }), "*");

        window.cod = {
            getBuildURL: () => sendDataToCod("url", getCodBuildURLs(store.getState().commonSettings)),
            getToyotaCode: () =>
                new Promise<void>((resolve, reject) => {
                    let { save } = store.getState();
                    if (!save.saved) {
                        store.dispatch(startConfigSave());
                        // All the logic for retrieving a tyCode are in Redux, but this logic isnt listening to actions.
                        // Manually subscribe to the store and wait until the saved boolean is true (or a save error is set).
                        const unsubscribe = store.subscribe(() => {
                            save = store.getState().save;
                            if (save.saved && save.data) {
                                sendDataToCod("tyCode", save.data.ConfigurationCode);
                                unsubscribe();
                                resolve();
                            } else if (save.error) {
                                unsubscribe();
                                reject();
                            }
                        });
                    } else {
                        sendDataToCod("tyCode", save.data ? save.data.ConfigurationCode : "");
                        resolve();
                    }
                }),
        };
    }
};
